var React = require('react');

function CheckThin (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15 4.5L6.75 12.75L3 9","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"}));
}

CheckThin.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none"};

module.exports = CheckThin;

CheckThin.default = CheckThin;
